import React from "react";
import Grid from "@material-ui/core/Grid";
import ButtonBase from "@material-ui/core/ButtonBase";
import { QRCodeCanvas } from "qrcode.react";

function QrBarcode(props) {
  const { locInv, InvForFatora, color,sta } = props;

  const sty = {
    dirL: { direction: "ltr" },
  };
  return (
    <Grid item container style={sty.dirL}>
      <Grid item xs={12}>
        {(locInv?.Step_inv2 && sta.tot?.ZatcaQR) ?
          (
            <ButtonBase style={{ borderRadius: "3", margin: 0, padding: 0, marginTop: 0 }}>
              {
                <QRCodeCanvas value={sta.tot?.ZatcaQR} />
              }

            </ButtonBase>
          ) :
          (
            <ButtonBase style={{ border: "solid 1px", borderColor: color, padding: "0.1px" }}>
              {
                <img
                  src={`data:image/jpeg;base64,${InvForFatora.qr_image}`}
                  style={{ height: 120, width: 120 }}
                />
              }
            </ButtonBase>
          )}

      </Grid>
    </Grid>
  );
}
export default QrBarcode;
